var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.671 23.711a9.09 9.09 0 0 1-2.44-4.43 9.213 9.213 0 0 1 7.97-7.11c.015.589-.153 1.565.52 1.87a1.025 1.025 0 0 0 1.03-.05l6.12-4.079a.995.995 0 0 0 .45-.83.982.982 0 0 0-.45-.83l-6.12-4.08a.98.98 0 0 0-1.03-.05c-.694.29-.498 1.381-.52 1.96-9.283.739-13.645 12.431-6.95 19.04a1 1 0 0 0 1.42-1.41zM55.339 38.88a.996.996 0 0 0-.01 1.41 9.09 9.09 0 0 1 2.44 4.43 9.212 9.212 0 0 1-7.97 7.11v-.99a1.003 1.003 0 0 0-1.55-.83l-6.12 4.08a.998.998 0 0 0 0 1.66l6.12 4.08A1 1 0 0 0 49.8 59v-1.08a11.196 11.196 0 0 0 6.95-19.04.996.996 0 0 0-1.41 0zM4.6 31.361l15.27 15.08 15.09-9.43-1.88-1.85-10.33 6.39a1.003 1.003 0 0 1-1.35-.28 1.12 1.12 0 0 0-.92-.48 1.214 1.214 0 0 0-.77.28 1.014 1.014 0 0 1-1.31-.04l-7.29-6.66a1.01 1.01 0 0 1 .02-1.5 1.15 1.15 0 0 0 .41-.88 1.105 1.105 0 0 0-.21-.66 1.014 1.014 0 0 1 .29-1.43l9.91-6.13-1.85-1.83z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21 39.051a3.219 3.219 0 0 1 3.17.38l9.23-5.72-8.61-8.49-9.58 5.92a3.219 3.219 0 0 1-.27 2.38zm1.58-8.13a2.966 2.966 0 0 1 3.15 2.72 2.966 2.966 0 0 1-3.15 2.71 2.96 2.96 0 0 1-3.15-2.71 2.96 2.96 0 0 1 3.15-2.72zM44.79 14.061a3.22 3.22 0 0 1-3.17-.38l-9.36 5.79 8.62 8.51 9.7-6.01a3.219 3.219 0 0 1 .27-2.38zm-1.51 8.21a2.966 2.966 0 0 1-3.15-2.71 3.184 3.184 0 0 1 6.3 0 2.96 2.96 0 0 1-3.15 2.71z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 11.561a1.001 1.001 0 0 1 1.35.28 1.12 1.12 0 0 0 .92.48 1.214 1.214 0 0 0 .77-.28 1.014 1.014 0 0 1 1.31.04l7.29 6.66a.998.998 0 0 1-.02 1.49 1.187 1.187 0 0 0-.41.89 1.104 1.104 0 0 0 .21.66 1.001 1.001 0 0 1-.29 1.42l-10.04 6.22 1.85 1.83 15.21-9.5-15.27-15.08-15.22 9.51 1.88 1.85zM45.54 32.76a26.035 26.035 0 0 1 .06 2.681l14.4-9v-2.71zM45.6 40.501l14.4-9v-2.7l-14.4 9zM19.13 54.15a1.001 1.001 0 0 1-.7-.29L4 39.612v3.23l14.66 14.49 16.35-10.22v-2.69l-15.35 9.58a.988.988 0 0 1-.53.15z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.03 48.421 4 33.571v3.23l15.27 15.08 15.74-9.82v-2.72l-14.75 9.21a.997.997 0 0 1-1.23-.13zM43.6 33.981l-6.59 4.11v7.78l6.59-4.12zM27.17 17.261l-5.75 3.59 15.28 15.07 5.75-3.58zM43.28 18.84c-.66 0-1.15.38-1.15.72 0 .33.49.71 1.15.71s1.15-.38 1.15-.71c0-.34-.49-.72-1.15-.72zM20.79 34.351c.65 0 1.15-.38 1.15-.71 0-.34-.5-.72-1.15-.72-.66 0-1.15.38-1.15.72 0 .33.49.71 1.15.71z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundIcon);
export default __webpack_public_path__ + "static/media/refund-icon.c85cf8490420855f69190e39c928b7da.svg";
export { ForwardRef as ReactComponent };